import type { ReactNode } from 'react'
import { Dialog, DialogBackdrop, DialogPanel, Portal } from '@headlessui/react'
import { IconX } from '@tabler/icons-react'

import { cn } from 'utils/classMerge'

interface BaseModalProps {
  isOpen: boolean
  onClose: () => void
  onCloseX?: () => void
  children: ReactNode
  closeButton?: boolean
  maxSize?: string
  className?: string
  zIndex?: string
}

export default function BaseModal({
  isOpen,
  onClose,
  onCloseX,
  children,
  closeButton,
  maxSize,
  className,
  zIndex,
}: BaseModalProps) {
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      className={cn('tw-relative', zIndex)}
    >
      <Portal>
        <>
          <DialogBackdrop
            transition
            className="tw-fixed tw-inset-0 tw-bg-gray-500/75 tw-transition-opacity data-[closed]:tw-opacity-0 data-[enter]:tw-duration-300 data-[enter]:tw-ease-out data-[leave]:tw-ease-in"
          />
          <div className="tw-fixed tw-inset-0 tw-z-10 tw-w-screen tw-overflow-visible tw-overflow-y-auto">
            <div
              className={cn(
                'tw-flex tw-min-h-full tw-items-center tw-justify-center tw-p-0 tw-text-center',
              )}
              data-testid="base-modal"
            >
              <DialogPanel
                transition
                className={cn(
                  maxSize,
                  className,
                  'tw-data-[closed]:tw-translate-y-4 tw-data-[closed]:tw-opacity-0 tw-data-[enter]:tw-duration-300 tw-data-[enter]:tw-ease-out tw-data-[leave]:tw-ease-in tw-sm:tw-my-8 tw-sm:tw-w-full tw-data-[closed]:tw-sm:tw-translate-y-0 tw-data-[closed]:tw-sm:tw-scale-95 tw-relative tw-w-full tw-transform tw-overflow-visible tw-overflow-y-auto tw-rounded-2xl tw-bg-white tw-text-left tw-shadow-xl tw-transition-all',
                )}
              >
                {closeButton && (
                  <button
                    type="button"
                    onClick={onCloseX || onClose}
                    className="tw-font-inherit tw-absolute tw-right-4 tw-top-4 tw-m-0 tw-flex tw-appearance-none tw-items-center tw-border-none tw-bg-transparent tw-p-0 tw-text-inherit tw-shadow-none tw-outline-none tw-ring-0"
                  >
                    <span className="tw-sr-only">Close</span>
                    <IconX
                      size={20}
                      stroke={2}
                      className="tw-stroke-gray-700 hover:tw-stroke-gray-900"
                    />
                  </button>
                )}
                {children}
              </DialogPanel>
            </div>
          </div>
        </>
      </Portal>
    </Dialog>
  )
}
